import styled from 'styled-components';
import type { HTMLAttributes } from 'react';

import { MAX_WIDTH_TABLET } from 'utils/constants';

export const Card = styled.section`
  position: fixed;
  right: 1%;
  bottom: 72px;
  z-index: 9999999;
  min-height: 159px;
  width: 603px;
  max-width: calc(100% - 32px);
  box-sizing: border-box;
  padding: 20px 40px 30px 40px;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  box-shadow: 0px 8px 16px rgba(38, 38, 38, 0.12);

  @media (max-width: ${MAX_WIDTH_TABLET}px) {
    left: 16px;
    right: 16px;
    bottom: 16px;
    width: auto;
    max-width: none;
    padding: 20px 16px 24px 16px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;

  padding: 8px;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Text = styled.p`
  margin: 16px 0px;
  font-size: 0.75rem;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const RatingRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 16px 0;
`;

export const RatingOption = styled.button`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  min-width: 0;

  padding: 10px 2px;
  background-color: transparent;
  border: none;
  cursor: pointer;

  span {
    font-size: 0.75rem;
    font-style: italic;
    line-height: 1.25;
    text-align: center;
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const Actions = styled.div`
  margin-top: 16px;
  button {
    width: 100%;
  }
`;

export const SubmitError = styled.p`
  margin: 0 0 8px 0;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.error};
`;

export const SubmitButtonWrap = styled.div<{ $submitted: boolean } & HTMLAttributes<HTMLDivElement>>`
  ${({ $submitted, theme }) =>
    $submitted &&
    `
    button:disabled {
      background: ${theme.colors.success} !important;
      border-color: ${theme.colors.success} !important;
      color: ${theme.colors.white} !important;
      opacity: 1;
      cursor: default;
    }
  `}
`;
